import React from "react";

export type SelectedALState = {
    selectedAL:string
    // setSelectedAL:(s:string)=>void
}

export const SelectedALContext = React.createContext<SelectedALState>({selectedAL:''})
